export default __webpack_public_path__ + "static/media/CLCoachDashboard.66a0042f.svg";